export enum UserBadgeType {
  FOUNDER = 'founder',
  GIGACHAD = 'gigachad',
  LIFETIME = 'lifetime',
  SPONSOR = 'sponsor',
  VETERAN = 'veteran',
  NOSTR = 'nostr'
}